export default __webpack_public_path__ + "static/media/flag-vn.1dd9f8db.svg";